import React, { Component } from "react";
import { MdWarning } from "react-icons/md";

export default class ErrorBoundaries extends Component {
  constructor(props) {
    super(props);
    this.state = { isErrorOccurred: false };
  }

  static getDerivedStateFromError(isError) {
    return { isErrorOccurred: isError };
  }

  componentDidCatch(error) {
    console.log("...error", error);
  }

  render() {
    if (this.state.isErrorOccurred) {
      return <div style={{ color: "#ff3400", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
        <MdWarning style={{ marginRight: "6px", fontSize: "19px" }}/>Something went wrong
    </div>;
    } else {
      return this.props.children;
    }
  }
}
